import {useTranslation} from "react-i18next";
import {Box, Paper, Stack, Typography} from "@mui/material";
import EmptyState from "../../../../util/component/EmptyState";
import {IRaNote} from "../../models/models";

const NoteList = ({isShowingNewNote, notes}: {isShowingNewNote: boolean, notes: IRaNote[]}) => {
    const {t} = useTranslation(['network']);

    return (
        !notes || notes.length === 0 ?
            <EmptyState title={t("common.emptyState")} /> :
            <>
                {
                    notes
                        ?.map((note, index) => (
                            <Paper variant="outlined" sx={{p: 2}}>
                                <Stack rowGap={2}>
                                    <Box>
                                        <Typography variant="body2">
                                            {note.creationOperator}
                                        </Typography>
                                        <Typography variant="caption">
                                            {note.requestCreationDate}
                                        </Typography>
                                    </Box>
                                    <Typography sx={{ whiteSpace: 'pre-wrap'}}>
                                        {note.body}
                                    </Typography>
                                </Stack>
                            </Paper>
                        ))
                        .reverse()
                }
            </>
    );
};

export default NoteList;
